module.controller('regulationHomeCtrl', [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService', 'regulationHomeDataresolve', regulationHomeCtrlFn ]);
function regulationHomeCtrlFn($scope, $rootScope, $state, regulationService, alertService, regulationHomeData) {

	$scope.idregulation = $state.params.id;
	$scope.regulationHome = {

	};
	$scope.loading = false;

	/**
	 * 
	 * @param idUser
	 */
	$scope.loadHomeInfo = function(idregulation) {
		$scope.loading = true;

		//regulationService.getRegulation(idregulation).then(function(response) {
			$scope.loading = false;
			var responseData = regulationHomeData.getData();//response.getData();
			$scope.regulationHome = responseData;

//		}, function(response) {
//			$scope.loading = false;
//		});
	};

	$scope.loadHomeInfo($scope.idregulation);

}
